import throttle from "../../utils/throttle";
import isPartiallyInViewport from "../../utils/isPartiallyInViewport";

// Load YouTube IFrame API
function loadYouTubeAPI() {
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// YouTube player instances
const players = {};

// This function will be called by the YouTube IFrame API
window.onYouTubeIframeAPIReady = function () {
  document
    .querySelectorAll(".hero-video-container iframe")
    .forEach((iframe) => {
      const videoId = iframe.getAttribute("data-youtube-id");
      if (videoId) {
        players[videoId] = new YT.Player(iframe.id, {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
          playerVars: {
            autoplay: 1,
            loop: 1,
            playlist: videoId,
            mute: 1,
            controls: 0,
            showinfo: 0,
            rel: 0,
            modestbranding: 1,
            playsinline: 1,
          },
        });
      }
    });
};

function onPlayerReady(event) {
  // Start playing when ready
  const player = event.target;

  // Set video to fill container
  player.setSize("100%", "100%");

  // Some videos might need a specific quality setting for better coverage
  try {
    // Try to set to highest available quality for better coverage
    player.setPlaybackQuality("hd1080");
  } catch (e) {
    // If setting quality fails, continue anyway
    console.log("Could not set video quality", e);
  }

  player.playVideo();
}

function onPlayerStateChange(event) {
  const iframe = event.target.getIframe();
  const container = iframe.closest(".hero-video-container");

  // Update poster visibility based on player state
  if (event.data === YT.PlayerState.PLAYING) {
    container.querySelector(".hero-video-poster").style.opacity = "0";
    container.classList.remove("paused");
  } else if (
    event.data === YT.PlayerState.PAUSED ||
    event.data === YT.PlayerState.ENDED
  ) {
    container.querySelector(".hero-video-poster").style.opacity = "1";
    container.classList.add("paused");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const heroVideoContainers = document.querySelectorAll(
    ".hero-video-container"
  );

  if (heroVideoContainers.length > 0) {
    loadYouTubeAPI();

    function toggleVideo(container) {
      const videoId = container
        .querySelector("iframe")
        .getAttribute("data-youtube-id");
      const player = players[videoId];

      if (!isPartiallyInViewport(container)) {
        if (player && typeof player.pauseVideo === "function") {
          player.pauseVideo();
          container.classList.add("paused");
        }
      } else {
        if (player && typeof player.playVideo === "function") {
          player.playVideo();
          container.classList.remove("paused");
        }
      }
    }

    // Attach a separate throttled function for each hero-video
    const throttledFunctions = Array.from(heroVideoContainers).map(
      (container) => throttle(() => toggleVideo(container), 100)
    );

    // Attach the scroll event listener
    window.addEventListener("scroll", () => {
      throttledFunctions.forEach((fn) => fn());
    });

    // Initial check after YouTube API is loaded
    window.addEventListener("load", () => {
      setTimeout(() => {
        heroVideoContainers.forEach((container) => toggleVideo(container));
      }, 1000); // Give time for YouTube players to initialize
    });
  }
});
